module.exports = __webpack_public_path__ + "static/media/man-home.31954287.png";